import { RootState } from '../store';

export const currentStep = (state: RootState) => state.step.currentStep;
